import { Box } from '@mui/material'

import DownloadApp from '../../help/DownloadApp'

const SidebarFooter = () => {
  return (
    <Box sx={{ p: 1.5 }}>
      <DownloadApp />
    </Box>
  )
}

export default SidebarFooter
